import { render, staticRenderFns } from "./Academy.vue?vue&type=template&id=170ecbf4&scoped=true&"
import script from "./Academy.vue?vue&type=script&lang=ts&"
export * from "./Academy.vue?vue&type=script&lang=ts&"
import style0 from "./Academy.vue?vue&type=style&index=0&id=170ecbf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170ecbf4",
  null
  
)

export default component.exports